import React, { useState, useEffect, useMemo } from "react"
import { Form, Button, Spinner } from "react-bootstrap"
import { CustomInput } from "../custom-input/CustomInput"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { newPreEnrolmentAction } from "../../pages/pre-enrolment/preEnrolmentAction"
import { fetchCoursesAction } from "../../pages/course/courseAction"

let initialState = {
  fName: "",
  lName: "",
  mobile: "",
  email: "",
  dob: "",
  street: "",
  suburb: "",
  state: "",
  postcode: "",
  goals: "",
  challenges: "",
  howReachGoal: "",
  whereFrom: "",
  classGroup: "weekdays",
  emergencyContactName: "",
  emergencyContactPhone: "",
  referralCode: "",
}

export const EnrolmentForm = () => {
  const dispatch = useDispatch()
  const { courses } = useSelector((state) => state.course)
  const { user } = useSelector((state) => state.user)
  const [crs, setCrs] = useState([])
  const [enrolment, setEnrolment] = useState(initialState)
  const { isLoading } = useSelector((state) => state.enroll)

  const params = useMemo(() => {
    const p = new URLSearchParams()
    p.set("branch", user?.branch)
    return p
  }, [user?.branch])

  useEffect(() => {
    dispatch(fetchCoursesAction(params.toString()))
  }, [dispatch, params])

  useEffect(() => {
    setCrs(courses)
  }, [courses])

  const handleOnChange = (e) => {
    let { name, value, checked } = e.target
    value = name === "sendEnrolmentConfirmationEmail" ? checked : value

    setEnrolment({
      ...enrolment,
      [name]: value,
    })
  }

  const handleOnSubmit = (e) => {
    e.preventDefault()
    dispatch(newPreEnrolmentAction(enrolment)) && setEnrolment(initialState)
  }

  const inputFields = [
    {
      name: "fName",
      type: "text",
      label: "First Name*",
      placeholder: "First Name",
      value: enrolment.fName,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "lName",
      type: "text",
      label: "Last Name*",
      placeholder: "Last Name",
      value: enrolment.lName,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "mobile",
      type: "number",
      label: "mobile*",
      placeholder: "Student's mobile number",
      value: enrolment.mobile,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "email",
      type: "email",
      label: "Email*",
      autoComplete: "email",
      placeholder: "Student's@email",
      value: enrolment.email,
      required: true,
      onChange: handleOnChange,
      disabled: false,
    },
    {
      name: "dob",
      type: "date",
      label: "DOB*",
      placeholder: "...",
      value: enrolment.dob,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "street",
      label: "Street*",
      placeholder: "george st",
      value: enrolment.street,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "suburb",
      label: "Suburb*",
      placeholder: "Sydney",
      value: enrolment.suburb,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "postcode",
      type: "number",
      label: "Postcode*",
      max: 9999,
      value: enrolment.postcode,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "state",
      label: "State*",
      value: enrolment.state,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "emergencyContactName",
      label: "Emergency Contact Name*",
      value: enrolment.emergencyContactName,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "emergencyContactPhone",
      type: "number",
      label: "Emergency Contact Phone*",
      value: enrolment.emergencyContactPhone,
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "goals",
      type: "number",
      label: " What are your 3 main goals of taking this program?*",
      value: enrolment.goals,
      as: "textarea",
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "challenges",
      label:
        " What are your 3 biggest challenges getting into the tech industry?*",
      value: enrolment.challenges,
      as: "textarea",
      required: true,
      onChange: handleOnChange,
    },
    {
      name: "howReachGoal",
      label: "How this program can help you to reach your goals?*",
      value: enrolment.howReachGoal,
      as: "textarea",
      required: true,
      onChange: handleOnChange,
    },

    {
      name: "whereFrom",
      label: "Where did you hear about our program first?",
      value: enrolment.whereFrom,
      onChange: handleOnChange,
    },
    {
      name: "referralCode",
      label: "Referral/Discount Code",
      value: enrolment.referralCode,
      onChange: handleOnChange,
    },
  ]

  return (
    <div>
      <div className="mb-3">
        <Link to="/enrol" role="button" className="btn btn-outline-secondary">
          &lt; Back
        </Link>
      </div>
      {isLoading && <Spinner variant="primary" animation="border" />}
      <div className="enrolment-info text-primary">
        <h4>
          Apply to Become a Job Ready Full-Stack Web Development in 6 months
        </h4>
        <div className="">Commence: 10-01-2022</div>
      </div>
      <Form onSubmit={handleOnSubmit} className="enrollment-form">
        {inputFields.map((attributes, i) => (
          <CustomInput key={i} {...attributes} />
        ))}

        <div className="form-group">
          <label className="col-form-label" htmlFor="classGroup">
            Training location?*
          </label>{" "}
          <br />
          <select
            name="location"
            id=""
            className="form-control"
            onChange={handleOnChange}
            defaultValue={0}
          >
            <option value={0} disabled>
              -- Select a location --
            </option>
            <option value="sydney">Sydney</option>
            <option value="canberra">Canberra</option>
          </select>
        </div>

        <div className="form-group">
          <label className="col-form-label" htmlFor="classGroup">
            Select Course*
          </label>
          <select
            name="courseCode"
            className="form-control mb-3"
            onChange={(e) =>
              setEnrolment({
                ...enrolment,
                course: {
                  courseCode: e.target.value,
                },
              })
            }
          >
            <option value="">Select Course</option>
            {crs.map((c) => (
              <option value={c.courseCode} key={c._id}>
                {c.courseCode}
              </option>
            ))}
          </select>
        </div>

        <hr />

        <div className="py-3 text-danger">
          Only limited spots available. HURRY!!!
        </div>
        <div className="py-2 text-info">
          <strong>What's Next: </strong>
          We may contact you for the further information and qualification
          check.
        </div>

        <div className="d-grid py-3">
          <Button type="submit">Apply For Enrollment</Button>
        </div>
      </Form>
    </div>
  )
}
